// aulaCurso.js — Utilidades del aula (curso con lecciones en video, tipo LearnDash).
//
// Toma la respuesta de mentor/start.php (estructura del curso + avance por video)
// y la deja como una lista plana de lecciones, que es lo que pintan la página del
// curso («Contenido del Curso») y la vista de lección.
import { BACKEND_BASE } from '../../services/api';

/** Lecciones en orden, con su módulo, su video y si ya está completada. */
export const leccionesDelCurso = (data) => {
  const videos = Array.isArray(data?.videos) ? data.videos : [];
  const lista = [];
  (data?.estructura?.modulos || []).forEach((m) => {
    (m.lecciones || []).forEach((l) => {
      const video = videos.find(v => v.modulo_numero === m.numero && v.leccion_numero === l.numero) || null;
      lista.push({
        modulo: m.numero,
        moduloTitulo: m.titulo,
        numero: l.numero,
        titulo: l.titulo,
        items: l.items || [],
        video,
        completado: !!video?.completado,
      });
    });
  });
  return lista;
};

/** Pasos completados, total y porcentaje (el mismo cálculo que el servidor). */
export const avanceDelCurso = (lecciones) => {
  const total = lecciones.length;
  const hechas = lecciones.filter(l => l.completado).length;
  return { total, hechas, porcentaje: total ? Math.round((hechas / total) * 100) : 0 };
};

/** ¿El aula de este proyecto vive en /contenidos para ese curso? */
export const aulaEnContenidos = (proyecto, documentId) => {
  const a = proyecto?.config_json?.aula || {};
  return !!(a.activo && a.en_contenidos && String(a.documento_contenidos) === String(documentId));
};

/**
 * Dirección de una lección en el aula. Con `aula.en_contenidos` el curso de
 * `aula.documento_contenidos` se ve en /contenidos (?modulo=&leccion=); si no,
 * en /aula/:documento/:modulo/:leccion.
 */
export const urlLeccion = (documentId, leccion, proyecto = null) => (
  aulaEnContenidos(proyecto, documentId)
    ? `/contenidos?modulo=${leccion.modulo}&leccion=${leccion.numero}`
    : `/aula/${documentId}/${leccion.modulo}/${leccion.numero}`
);

/** La misma lección en el modo mentor de la plataforma (con todas sus funciones). */
export const urlLeccionMentor = (documentId, leccion) =>
  `/mentor/${documentId}?modulo=${leccion.modulo}&leccion=${leccion.numero}`;

/** Colores y opciones del aula del proyecto (config_json.aula). */
export const configAula = (proyecto) => {
  const a = proyecto?.config_json?.aula || {};
  return {
    ...a,
    primario: a.color_primario || '#8800cc',
    secundario: a.color_secundario || '#60068d',
    titulo: a.color_titulo || '#012947',
    permitirMarcar: a.permitir_marcar !== false,
  };
};

/** Página del curso a la que vuelve el aula («Volver al Curso»). */
export const urlCurso = (proyecto, documentId) =>
  proyecto?.config_json?.aula?.cursos?.[String(documentId)] || '/contenidos';

export const urlArchivo = (ruta) => (!ruta ? null : (/^https?:\/\//.test(ruta) || ruta.startsWith('/') ? ruta : `${BACKEND_BASE}/${ruta}`));
